<template>
    <div class="row justify-content-center">
        <div class="col-md-6">
            <h4 class="text-center" style="font-weight:bold; text-transform:uppercase">Modification des informations</h4>
            <form @submit.prevent="onUpdateForm">
                <div class="form-group">
                    <label>Nom</label>
                    <input type="text" class="form-control" v-model="user.name" style="border-radius:10px 10px 10px 10px;" required>
                </div>

                <div class="form-group">
                    <label>Contact</label>
                    <input type="text" class="form-control" v-model="user.number" style="border-radius:10px 10px 10px 10px;" required>
                </div>

                <div class="form-group">
                    <label>Role</label>
                    <select class="form-control" v-model="user.role" id="" style="border-radius:10px 10px 10px 10px;">
                        <option value="0">Client</option>
                        <option value="1">Livreur</option>
                        <option value="2">Commerciaux</option>
                        <option value="3">Manager</option>
                        <option value="4">Administrateur</option>
                    </select>
                </div>

                <div class="form-group">
                    <button class="btn btn-success btn-block" style="background-color:#34B76E; color:white; border-radius:10px 10px 10px 10px;">Modifier</button>
                </div>
                <br><br><br><br>
            </form>
        </div>
    </div>
</template>

<script>
    import { db } from '../../main';

    export default {
        data() {
            return {
                user: {}
            }
        },
        created() {
            let dbRef = db.collection('users').doc(this.$route.params.id);
            dbRef.get().then((doc) => {
                this.user = doc.data();
            }).catch((error) => {
                console.log(error)
            })
        },
        methods: {
            onUpdateForm(event) {
                event.preventDefault()
                db.collection('users').doc(this.$route.params.id)
                .update(this.user).then(() => {
                    console.log("Mise à jour effectuée!");
                    this.$router.push('Clients')
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }
</script>